import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarLayout from 'components/Layout/Layout';
import { API_URL } from 'env';
import { toast } from "react-toastify";
import TinyMce from 'components/GbCpn/TinyMce';
import { Breadcrumb, Button, Checkbox, Input, Select } from 'antd';
import { ArrowLeftIcon } from '@phosphor-icons/react';

const AddDailyReading: React.FC = () => {
    const navigate = useNavigate();
    const [locale, setLocale] = useState<'en' | 'vi'>('en');
    const [form, setForm] = useState({
        title: { en: '', vi: '' },
        number: 0,
        description: { en: '', vi: '' },
        key: '',
        is_active: false,
    });
    const [loading, setLoading] = useState(false);

    const handleSave = async () => {
        const currentTitle = locale === 'en' ? form.title.en : form.title.vi;
        if (!currentTitle.trim()) { toast.error("Vui lòng nhập tiêu đề"); return; }
        if (!form.key.trim()) { toast.error("Vui lòng nhập type"); return; }

        try {
            setLoading(true);
            const localeData = localStorage.getItem('userData');
            const token = localeData ? JSON.parse(localeData).access_token : localStorage.getItem('token');
            const response = await fetch(`${API_URL}api/v1/be/numerology_indices`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify(form),
            });
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            const json = await response.json();
            if (json.status) {
                toast.success("Thêm mới thành công");
                navigate('/numerology');
            } else {
                toast.error('Có lỗi: ' + (json.message || 'Unknown error'));
            }
        } catch (error: unknown) {
            toast.error('Lỗi khi thêm mới: ' + (error instanceof Error ? error.message : String(error)));
        } finally {
            setLoading(false);
        }
    };

    return (
        <SidebarLayout>
            <div className="space-y-4">
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => navigate('/numerology')}
                        className="flex items-center justify-center w-7 h-7 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors cursor-pointer"
                    >
                        <ArrowLeftIcon size={16} />
                    </button>
                    <Breadcrumb
                        separator=">"
                        items={[
                            { title: <span className="cursor-pointer" onClick={() => navigate('/numerology')}>Numerology</span> },
                            { title: 'Add New' },
                        ]}
                    />
                </div>

                <div className="bg-bg-card border border-border rounded-xl p-6 space-y-5">
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <p className="text-xs font-medium text-text-secondary mb-1.5">Language</p>
                            <Select
                                value={locale}
                                onChange={val => setLocale(val)}
                                className="w-full"
                                options={[{ value: 'en', label: 'English' }, { value: 'vi', label: 'Vietnamese' }]}
                            />
                        </div>
                        <div>
                            <p className="text-xs font-medium text-text-secondary mb-1.5">Title ({locale.toUpperCase()})</p>
                            <Input
                                value={locale === 'en' ? form.title.en : form.title.vi}
                                onChange={e => setForm({ ...form, title: { ...form.title, [locale]: e.target.value } })}
                                placeholder="Enter title"
                            />
                        </div>
                        <div>
                            <p className="text-xs font-medium text-text-secondary mb-1.5">Key</p>
                            <Input
                                value={form.key}
                                onChange={e => setForm({ ...form, key: e.target.value })}
                                placeholder="e.g. life_path"
                            />
                        </div>
                        <div>
                            <p className="text-xs font-medium text-text-secondary mb-1.5">Number</p>
                            <Input
                                type="number"
                                min={1}
                                max={9}
                                value={form.number}
                                onChange={e => setForm({ ...form, number: Number(e.target.value) })}
                            />
                        </div>
                    </div>

                    <div>
                        <p className="text-xs font-medium text-text-secondary mb-1.5">Nội dung ({locale.toUpperCase()})</p>
                        <TinyMce
                            defaultValue={locale === 'en' ? form.description.en : form.description.vi}
                            onChange={value => setForm({ ...form, description: { ...form.description, [locale]: value } })}
                        />
                    </div>

                    <Checkbox
                        checked={form.is_active}
                        onChange={e => setForm({ ...form, is_active: e.target.checked })}
                    >
                        Active
                    </Checkbox>

                    <div className="flex justify-end gap-2 pt-2 border-t border-border">
                        <Button onClick={() => navigate('/numerology')} disabled={loading}>Cancel</Button>
                        <Button type="primary" onClick={handleSave} loading={loading}>Add</Button>
                    </div>
                </div>
            </div>
        </SidebarLayout>
    );
};

export default AddDailyReading;
